module.exports = __webpack_public_path__ + "b7d48036bd1fd326be58ca2c44afdc84.svg";